import hoistNonReactStatics from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useQuery } from 'react-apollo';

import getGqlOperationName from '../../../../utils/getGqlOperationName';

const dynamicTreeBodyMapper = Component => {
  const Hoc = props => {
    const {
      gqlQuery,
      gqlVariables,
      formatAfterGqlQuery,
      preloadLeafIds,
      gqlSkip,
    } = props;

    const dataPropertyName = useMemo(() => getGqlOperationName(gqlQuery), [
      gqlQuery,
    ]);

    const { data, loading, error } = useQuery(gqlQuery, {
      variables: { ...gqlVariables, leafIds: preloadLeafIds },
      skip: gqlSkip,
    });

    const items = useMemo(() => {
      if (!data) {
        return [];
      }
      const rawItems = data[dataPropertyName];
      return rawItems && formatAfterGqlQuery
        ? formatAfterGqlQuery(rawItems)
        : rawItems;
    }, [data, dataPropertyName, formatAfterGqlQuery]);

    return (
      <Component {...props} error={error} items={items} loading={loading} />
    );
  };

  Hoc.displayName = `dynamicTreeBodyMapper(${
    Component.displayName || Component.name
  })`;

  Hoc.propTypes = {
    preloadLeafIds: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ),
    gqlQuery: PropTypes.object.isRequired,
    gqlVariables: PropTypes.object.isRequired,
    gqlSkip: PropTypes.bool,
    formatAfterGqlQuery: PropTypes.func,
    isSyntheticRootNodeAlwaysVisible: PropTypes.bool,
  };

  Hoc.defaultProps = {
    preloadLeafIds: [],
    formatAfterGqlQuery: null,
    isSyntheticRootNodeAlwaysVisible: false,
    gqlSkip: false,
  };

  return hoistNonReactStatics(Hoc, Component);
};

export default dynamicTreeBodyMapper;
